// src/scripts/fluco-lib/events.js
var EVENTS = {
  SHOPIFY_BLOCK_SELECT: "shopify:block:select",
  SHOPIFY_BLOCK_DESELECT: "shopify:block:deselect",
  SHOPIFY_SECTION_DESELECT: "shopify:section:deselect",
  SHOPIFY_SECTION_SELECT: "shopify:section:select",
  SHOPIFY_SECTION_LOAD: "shopify:section:load",
  SHOPIFY_SECTION_UNLOAD: "shopify:section:unload",
  COUNTDOWN_TIMER_COMPLETED_EVENT: "fluco_section:countdown_timer_completed"
};
var events_default = EVENTS;

// node_modules/srraf/dist/srraf.es.js
var n;
var e;
var i;
var o;
var t;
var r;
var f;
var d;
var p;
var u = [];
function w(n2, a) {
  return e = window.pageXOffset, o = window.pageYOffset, r = window.innerHeight, d = window.innerWidth, void 0 === i && (i = e), void 0 === t && (t = o), void 0 === p && (p = d), void 0 === f && (f = r), (a || o !== t || e !== i || r !== f || d !== p) && (!function(n3) {
    for (var w2 = 0; w2 < u.length; w2++) u[w2]({ x: e, y: o, px: i, py: t, vh: r, pvh: f, vw: d, pvw: p }, n3);
  }(n2), i = e, t = o, f = r, p = d), requestAnimationFrame(w);
}
function srraf_es_default(e2) {
  return u.indexOf(e2) < 0 && u.push(e2), n = n || w(performance.now()), { update: function() {
    return w(performance.now(), true), this;
  }, destroy: function() {
    u.splice(u.indexOf(e2), 1);
  } };
}

// src/scripts/fluco-lib/video-pair.js
var VideoPair = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      desktopVideo: "video.fluco-video--desktop",
      mobileVideo: "video.fluco-video--mobile"
    };
    this.classes = {};
    this.desktopBreakpoint = 720;
  }
  static observedAttributes = ["data-visible"];
  connectedCallback() {
    this.desktopVideo = this.querySelector(this.selectors.desktopVideo);
    this.mobileVideo = this.querySelector(this.selectors.mobileVideo);
    this.viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    this.aboveMobile = this.viewportWidth > this.desktopBreakpoint;
    if (this.aboveMobile) {
      if (this.desktopVideo) {
        this.desktopVideo.poster = this.desktopVideo.getAttribute("data-poster");
        const desktopVideoImg = this.desktopVideo.querySelector("img");
        if (desktopVideoImg) {
          desktopVideoImg.src = desktopVideoImg.getAttribute("data-src");
        }
      }
    }
    this.widthWatcher = srraf_es_default(({ vw, pvw }) => {
      if (vw === pvw) return;
      this.viewportWidth = vw;
      const nowAboveMobile = vw > this.desktopBreakpoint;
      if (nowAboveMobile !== this.aboveMobile) {
        this.aboveMobile = nowAboveMobile;
        this.swapToCorrectVideo();
      }
    });
  }
  attributeChangedCallback(name, _oldValue, newValue) {
    switch (name) {
      case "data-visible":
        if (newValue === "true") {
          this.playVideo(
            this.aboveMobile ? this.desktopVideo : this.mobileVideo
          );
        } else {
          this.pauseVideo(
            this.aboveMobile ? this.desktopVideo : this.mobileVideo
          );
        }
        break;
    }
  }
  swapToCorrectVideo() {
    if (this.aboveMobile) {
      this.pauseVideo(this.mobileVideo);
      this.loadVideo(this.desktopVideo);
      this.playVideo(this.desktopVideo);
    } else {
      this.pauseVideo(this.desktopVideo);
      this.loadVideo(this.mobileVideo);
      this.playVideo(this.mobileVideo);
    }
  }
  loadVideo(video) {
    if (!video) return;
    video.load();
  }
  playVideo(video) {
    if (!video) return;
    video.muted = true;
    video.play();
  }
  pauseVideo(video) {
    if (!video) return;
    video.pause();
  }
};
if (!customElements.get("fluco-video-pair")) {
  customElements.define("fluco-video-pair", VideoPair);
}

// src/scripts/sections/section-hero-gallery-1.js
var { SHOPIFY_BLOCK_SELECT, SHOPIFY_BLOCK_DESELECT } = events_default;
var FlucoHeroGallerySlideshow = class extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      slides: "[js-slide]",
      thumbnails: "[js-thumbnail]",
      slideByBlockId: (blockId) => `[js-slide][data-block-id="${blockId}"]`,
      thumbByBlockId: (blockId) => `[js-thumbnail][data-block-id="${blockId}"]`,
      activeSlide: "[js-slide][data-active]",
      activeThumb: "[js-thumbnail][data-active]",
      lazyImages: "img[loading='lazy']",
      VideoPair: "fluco-video-pair"
    };
    this.attrs = {
      active: "data-active",
      visible: "data-visible"
    };
  }
  connectedCallback() {
    this.thumbnails = this.querySelectorAll(this.selectors.thumbnails);
    this.thumbnails.forEach((thumbnail) => {
      thumbnail.addEventListener("click", (event) => {
        this.gotoSlideByBlockId(event.currentTarget.dataset.blockId);
      });
      thumbnail.addEventListener("mouseover", (event) => {
        this.preloadSlideByBlockId(event.currentTarget.dataset.blockId);
      });
      thumbnail.addEventListener("focus", (event) => {
        this.preloadSlideByBlockId(event.currentTarget.dataset.blockId);
      });
    });
    this.eventController = new AbortController();
    this.eventOptions = { signal: this.eventController.signal };
    this.parentElement.addEventListener(
      SHOPIFY_BLOCK_SELECT,
      (event) => {
        this.gotoSlideByBlockId(event.detail.blockId);
      },
      this.eventOptions
    );
    this.parentElement.addEventListener(
      SHOPIFY_BLOCK_DESELECT,
      () => this.gotoFirstSlide(),
      this.eventOptions
    );
  }
  disconnectedCallback() {
    this.eventController.abort();
  }
  /**
   * Preload media within a slide so that the media is loaded premptively.
   * @param {String} blockId - The block ID for the slide.
   */
  preloadSlideByBlockId(blockId) {
    const slide = this.querySelector(this.selectors.slideByBlockId(blockId));
    if (!slide) {
      return;
    }
    const lazyImages = slide.querySelectorAll(this.selectors.lazyImages);
    lazyImages.forEach((image) => {
      image.loading = "eager";
    });
  }
  gotoFirstSlide() {
    const firstSlide = this.querySelector(this.selectors.slides);
    this.gotoSlideByBlockId(firstSlide.dataset.blockId);
  }
  /**
   * Go to slide based on block ID
   * @param {String} blockId - The block ID for the slide to activate.
   */
  gotoSlideByBlockId(blockId) {
    const newSlide = this.querySelector(this.selectors.slideByBlockId(blockId));
    const newThumb = this.querySelector(this.selectors.thumbByBlockId(blockId));
    if (!newSlide) {
      return;
    }
    const currentSlide = this.querySelector(this.selectors.activeSlide);
    const currentThumb = this.querySelector(this.selectors.activeThumb);
    if (currentSlide) {
      currentSlide.removeAttribute(this.attrs.active);
      currentSlide.inert = true;
      const currentSlideVideoPair = currentSlide.querySelector(
        this.selectors.VideoPair
      );
      currentSlideVideoPair?.setAttribute(this.attrs.visible, false);
    }
    if (newSlide) {
      newSlide.setAttribute(this.attrs.active, true);
      newSlide.inert = false;
      const newSlideVideoPair = newSlide.querySelector(this.selectors.VideoPair);
      newSlideVideoPair?.setAttribute(this.attrs.visible, true);
    }
    currentThumb?.removeAttribute(this.attrs.active);
    newThumb?.setAttribute(this.attrs.active, true);
  }
};
if (!customElements.get("fluco-hero-gallery-slideshow")) {
  customElements.define(
    "fluco-hero-gallery-slideshow",
    FlucoHeroGallerySlideshow
  );
}
